import { render, staticRenderFns } from "./vtable.vue?vue&type=template&id=4395db58&scoped=true&"
import script from "./vtable.vue?vue&type=script&lang=js&"
export * from "./vtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395db58",
  null
  
)

export default component.exports